'use strict'

var objectToString = Object.prototype.toString

module.exports = function(v) {
    return objectToString.apply(v) === '[object Function]'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/to-style/src/isFunction.js
// module id = 824
// module chunks = 0